import type { GetRecommendedDiets200 } from "@repo/api/catalog/api/schemas/get-recommended-diets200";
import { mapDietSearchResultsToDietCatalogDetail } from "@/features/diets/helpers/mappers";
import type { DietSearchResultsItemType } from "@/features/diets/types/diet-search-resilts.type";
import { DietCatalogCarouselSlider } from "@/features/static-builder/components/diet-catalog-carousel/diet-catalog-carousel-slider";

export const NoResultsDietsCarousel = ({
  recommendedDiets,
}: {
  recommendedDiets: GetRecommendedDiets200;
}) => {
  const prepareDiets = {
    diets: Object.entries(recommendedDiets).map(([_, value]) => {
      return value.diets.map((diet) => {
        return mapDietSearchResultsToDietCatalogDetail(
          diet as unknown as DietSearchResultsItemType,
        );
      });
    }),
  };

  return (
    <DietCatalogCarouselSlider
      showMenu={true}
      key="no-results-diets"
      diets={prepareDiets.diets.flat()}
    />
  );
};
